import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { EntryRequest } from 'modules/teams/domain/interfaces/entry-request';
import { Team } from 'modules/teams/domain/interfaces/team';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import { TournamentUser } from 'modules/teams/domain/interfaces/tournament-user';
import KitEditor from 'modules/teams/ui/components/kit-editor';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditTeam from '../components/edit-team';
import TeamsComponentsFormParticipantsListPart from '../components/form-parts/participants/participants-list';

import CreatePlayer from '../components/form-parts/players/create-player';
import TeamsComponentsFormPlayersListPart from '../components/form-parts/players/players-list';
import WaitingList from '../components/form-parts/waiting-list/waiting-list';

type Props = {
  team: Team;
  squad: TeamPlayer[];
  participants: TournamentUser[];
  waitingList: EntryRequest[];
};

const TeamComponentsEditForm = (props: Props) => {
  const userTournamentId = useSelector(authStoreUserTournamentId);

  const { team, squad, participants, waitingList } = props;

  if (!userTournamentId) {
    toast.error('Не удалось определить активный турнир, перезагрузите страницу');
    return null;
  }

  return (
    <Routes>
      <Route path="players" element={<TeamsComponentsFormPlayersListPart teamId={team.id} players={squad} />} />
      {/* `team.players`, а не `squad`: дубль ищется и среди вступивших участников, которых в составе нет. */}
      <Route
        path="players/create"
        element={<CreatePlayer tournamentId={userTournamentId} teamId={team.id} players={team.players ?? []} />}
      />
      <Route path="participants" element={<TeamsComponentsFormParticipantsListPart teamId={team.id} participants={participants} />} />
      <Route path="waiting-list" element={<WaitingList entryRequests={waitingList} />} />
      {/* `kits/*`, а не `kits`: адрес комплекта — вложенный сегмент, и точное
          совпадение отправило бы `/kits/home` в catch-all. */}
      <Route path="kits/*" element={<KitEditor team={team} />} />
      <Route path="*" element={<EditTeam team={team} tournamentId={userTournamentId} />} />
    </Routes>
  );
};

export default TeamComponentsEditForm;
